import { useEffect, useState } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { jwtDecode } from "jwt-decode";

import useLogin from "../../store/LoginStore";

import LoginForm from "../../Components/LoginForm";
import ModalWarning from "../../Components/ModalWarning/ModalWarning";
import ModalConfirmation from "../../Components/ModalConfirmation/ModalConfirmation";
import LangSwitcher from "../../Components/LangSwitcher";
import Loader from "../../Components/Loader";
import MainHeader from "../../Components/MainHeader/MainHeader";
import FacebookLoginBtn from "../../Components/FacebookLoginBtn";
import GoogleLoginBtn from "../../Components/GoogleLoginBtn";

import { ReactComponent as Tick } from "../../static/images/tick_sign.svg";
import { ReactComponent as Exclamation } from "../../static/images/exclamation_sign.svg";

import "./style.scss";

const Main = () => {
  const [warningModalToggle, setWarningModalToggle] = useState("");
  const [warningModalText, setWarningModalText] = useState("");
  const [warningButtonText, setWarningButtonText] = useState("");

  const [confirmModalToggle, setConfirmModalToggle] = useState("");

  const [confirmModalText, setConfirmModalText] = useState("");

  const navigate = useNavigate();
  const { t } = useTranslation();

  const { pathname, state } = useLocation();
  const [params] = useSearchParams();
  const queryParams = Object.fromEntries([...params]);
  const isSSO = params.get("isSSO");

  const ps10005000 = JSON.parse(localStorage.getItem("ps10005000"));

  const {
    password,
    phoneNumber,
    email,

    changePassword,
    changePhoneNumber,
    changeEmail,
    loginValidation,
    loginLoader,
    FetchAuth,
  } = useLogin();

  const confirmModalBtn = () => {
    navigate("/sessions");
    setConfirmModalToggle("");
  };

  const cancelModalBtn = (e) => {
    e.preventDefault();

    setConfirmModalToggle("");
    localStorage.removeItem("ps10005000");
    localStorage.removeItem("ps10004000");
    navigate("/");
  };

  const loginButton = async (e, loginType) => {
    e.preventDefault();
    FetchAuth(loginType);
  };

  useEffect(() => {
    if (ps10005000 && pathname === "/") {
      navigate("sessions");
      return;
    }

    if (pathname.includes("/usedInv")) {
      if (ps10005000) {
        const decodedToken = jwtDecode(ps10005000);
        if (decodedToken.email === queryParams.email) {
          setConfirmModalToggle("modal-confirm");
          setConfirmModalText(t("logged_in_with_email"));
        } else if (decodedToken.sub === queryParams.phoneNumber) {
          setConfirmModalToggle("modal-confirm");
          setConfirmModalText(t("logged_in_with_phone"));
        }
      } else {
        setWarningModalToggle("modal-warning");
        setWarningModalText(t("invitation_expired"));
        setWarningButtonText({ text: t("close"), func: () => {} });
      }
    }
  }, [ps10005000, navigate]);

  return (
    <>
      <ModalWarning
        warningText={warningModalText}
        changeModal={setWarningModalToggle}
        modalValue={warningModalToggle}
        buttonText={warningButtonText.text}
        Image={warningButtonText.text === t("close") ? Exclamation : Tick}
        handleButton={warningButtonText.func}
      />
      <ModalConfirmation
        modalText={confirmModalText}
        changeModal={setConfirmModalToggle}
        modalValue={confirmModalToggle}
        confirm={confirmModalBtn}
        cancel={cancelModalBtn}
        cancelButtonText={t("logout")}
      />

      <div className="main-container">
        <MainHeader />
        {isSSO && (
          <div className="sso-error">
            <p>
              We couldn’t find an account linked to this Google or Facebook
              profile.
            </p>
            <button
              type="button"
              onClick={() => {
                navigate("/role-selector?isSSO=true", {
                  state,
                });
              }}
            >
              Do you want to finish signing up?
            </button>
            <div className="login-sections-devider">
              <div id="login-sections-devider-left"></div>
              <span>or</span>
              <div id="login-sections-devider-right"></div>
            </div>
          </div>
        )}
        {!isSSO && (
          <>
            <div className="sso-section">
              <FacebookLoginBtn />
              <GoogleLoginBtn />
            </div>
            <div className="login-sections-devider">
              <div id="login-sections-devider-left"></div>
              <span>or</span>
              <div id="login-sections-devider-right"></div>
            </div>
          </>
        )}
        <div className={`manual-form-container ${!isSSO ? "top-margin" : ""}`}>
          <LoginForm
            onLogin={loginButton}
            phoneNumber={phoneNumber}
            changePhoneNumber={changePhoneNumber}
            email={email}
            changeEmail={changeEmail}
            password={password}
            changePassword={changePassword}
            loginValidation={loginValidation}
          />
        </div>
        {!isSSO && (
          <>
            <div id="bottom-login-section-devider"></div>
            <div
              className="create-account"
              onClick={() => {
                navigate("/register");
              }}
            >
              <span>{t("new_here")}</span>
              <h3>{t("register_now")}</h3>
            </div>
          </>
        )}

        <LangSwitcher />

        {loginLoader && <Loader />}
      </div>
    </>
  );
};

export default Main;
